<grid-header
    [view]="view"
    [ActionTemplate]="GridActionTemplate"
    [HeaderMenuTemplate]="GridHeaderMenuTemplate"
    [GridHeaderTopDropDownTemplate]="GridHeaderTopDropdownTemplate"
    [GridHeaderTitleTemplateDirective]="GridHeaderTitleTemplateDirective"
    [topBar]="topBar"
    (onSearch)="onSearchInner($event)"
    [searchtext]="searchtext"
    (onSearchDropDownChange)="onSearchDropDownChange.emit($event)"
    (onSettingClick)="onSettingClick.emit($event)"
    (onRefreshClick)="onRefreshClick.emit($event)"
    (onChangeViewHeader)="view = $event; onChangeView.emit($event)"
    (selectCustomFilter)="selectCustomFilterInner($event)"
></grid-header>

<div>
    <div>
        <div class="datatable-mainbody-wrapper" *ngIf="view == 'gridView'">
            <p class="records-found" *ngIf="topBar.showRowLength">
            <span *ngIf="!allSelectBtn"
                >{{ rows.length }} {{ 'Records found' | translate }} {{ topBar.selectRow }} {{ 'Selected' | translate }}
            </span>
            <a style="" *ngIf="rows.length < count && selectAll" (click)="onAllSelectFunc.emit($event)"
                >({{ !allSelectBtn ? 'Select all' : 'Deselect all' }} {{ count }} records )</a
            >
            </p>
            <rdatatable-header-filter
            [columns]="topBar.alphabetFilterColumns"
            [alphabetBar]="alphabetBar"
            [topBar]="topBar"
            [dropdownTemplate]="GridHeaderFilterDropdownTemplate"
            (onAlphabetAndColumnChange)="onAlphabetChangeInner($event)"
            [selectedAlphabet]="selectedAlphabet"
            >
            </rdatatable-header-filter>
            <ng-container *ngIf="rows.length > 0">
            <rgrid-header
                *ngIf="headerHeight"
                [sorts]="sorts"
                [longestContent]="longestContent"
                [sortType]="sortType"
                [scrollbarH]="scrollbarH"
                [innerWidth]="_innerWidth"
                [offsetX]="_offsetX | async"
                [dealsWithGroup]="groupedRows"
                [columns]="_internalColumns"
                [headerHeight]="headerHeight"
                [reorderable]="reorderable"
                [targetMarkerTemplate]="targetMarkerTemplate"
                [sortAscendingIcon]="cssClasses.sortAscending"
                [sortDescendingIcon]="cssClasses.sortDescending"
                [allRowsSelected]="allRowsSelected"
                [selectionType]="selectionType"
                (sort)="onColumnSort($event)"
                (resize)="onColumnResize($event)"
                (reorder)="onColumnReorder($event)"
                (select)="onHeaderSelect($event)"
                (columnContextmenu)="onColumnContextmenu($event)"
            >
            </rgrid-header>
            </ng-container>
            <rdatatable-body
                *ngIf="rows.length > 0"
                [groupRowsBy]="groupRowsBy"
                [longestContent]="longestContent"
                [groupedRows]="groupedRows"
                [rows]="_internalRows"
                [groupExpansionDefault]="groupExpansionDefault"
                [scrollbarV]="scrollbarV"
                [scrollbarH]="scrollbarH"
                [virtualization]="virtualization"
                [loadingIndicator]="loadingIndicator"
                [externalPaging]="externalPaging"
                [rowHeight]="rowHeight"
                [rowCount]="rowCount"
                [offset]="offset"
                [trackByProp]="trackByProp"
                [columns]="_internalColumns"
                [pageSize]="pageSize"
                [offsetX]="_offsetX | async"
                [rowDetail]="rowDetail"
                [groupHeader]="groupHeader"
                [selected]="selected"
                [innerWidth]="_innerWidth"
                [bodyHeight]="bodyHeight"
                [selectionType]="selectionType"
                [emptyMessage]="messages.emptyMessage"
                [rowIdentity]="rowIdentity"
                [rowClass]="rowClass"
                [selectCheck]="selectCheck"
                [displayCheck]="displayCheck"
                [summaryRow]="summaryRow"
                [summaryHeight]="summaryHeight"
                [summaryPosition]="summaryPosition"
                (page)="onBodyPage($event)"
                (activate)="activate.emit($event)"
                (rowContextmenu)="onRowContextmenu($event)"
                (select)="onBodySelect($event)"
                (scroll)="onBodyScroll($event)"
                (treeAction)="onTreeAction($event)"
            >
            </rdatatable-body>
        </div>
        <div *ngIf="view == 'listView'">
            <rbody-list-datatable-body
                *ngIf="rows.length > 0"
                [groupRowsBy]="groupRowsBy"
                [groupedRows]="groupedRows"
                [rows]="_internalRows"
                [groupExpansionDefault]="groupExpansionDefault"
                [scrollbarV]="scrollbarV"
                [rowTemplate]="GridBodyListRowTemplate"
                [scrollbarH]="false"
                [virtualization]="virtualization"
                [loadingIndicator]="loadingIndicator"
                [externalPaging]="externalPaging"
                [rowHeight]="rowHeight"
                [rowCount]="rowCount"
                [offset]="offset"
                [trackByProp]="trackByProp"
                [columns]="_internalColumns"
                [pageSize]="pageSize"
                [offsetX]="_offsetX | async"
                [rowDetail]="rowDetail"
                [groupHeader]="groupHeader"
                [selected]="selected"
                [innerWidth]="_innerWidth"
                [bodyHeight]="bodyHeight"
                [selectionType]="selectionType"
                [emptyMessage]="messages.emptyMessage"
                [rowIdentity]="rowIdentity"
                [rowClass]="rowClass"
                [selectCheck]="selectCheck"
                [displayCheck]="displayCheck"
                [summaryRow]="summaryRow"
                [summaryHeight]="summaryHeight"
                [summaryPosition]="summaryPosition"
                (page)="onBodyPage($event)"
                (activate)="activate.emit($event)"
                (rowContextmenu)="onRowContextmenu($event)"
                (select)="onBodySelect($event)"
                (scroll)="onBodyScroll($event)"
                (treeAction)="onTreeAction($event)">
            </rbody-list-datatable-body>
        </div>
         <div *ngIf="view == 'cardView'">
            <rbody-card-datatable-body
                *ngIf="rows.length > 0"
                [groupRowsBy]="groupRowsBy"
                [groupedRows]="groupedRows"
                [rows]="_internalRows"
                [groupExpansionDefault]="groupExpansionDefault"
                [scrollbarV]="scrollbarV"
                [rowTemplate]="GridBodyCardRowTemplate"
                [scrollbarH]="false"
                [virtualization]="virtualization"
                [loadingIndicator]="loadingIndicator"
                [externalPaging]="externalPaging"
                [rowHeight]="rowHeight"
                [rowCount]="rowCount"
                [offset]="offset"
                [trackByProp]="trackByProp"
                [columns]="_internalColumns"
                [pageSize]="pageSize"
                [offsetX]="_offsetX | async"
                [rowDetail]="rowDetail"
                [groupHeader]="groupHeader"
                [selected]="selected"
                [innerWidth]="_innerWidth"
                [bodyHeight]="bodyHeight"
                [selectionType]="selectionType"
                [emptyMessage]="messages.emptyMessage"
                [rowIdentity]="rowIdentity"
                [rowClass]="rowClass"
                [selectCheck]="selectCheck"
                [displayCheck]="displayCheck"
                [summaryRow]="summaryRow"
                [summaryHeight]="summaryHeight"
                [summaryPosition]="summaryPosition"
                (page)="onBodyPage($event)"
                (activate)="activate.emit($event)"
                (rowContextmenu)="onRowContextmenu($event)"
                (select)="onBodySelect($event)"
                (scroll)="onBodyScroll($event)"
                (treeAction)="onTreeAction($event)">
            </rbody-card-datatable-body>
        </div>
    </div>
</div>
<div *ngIf="rows.length == 0" class="norecords-block">{{ 'No records Found' | translate }}</div>

<div *ngIf="rows.length > 0">
    <rdatatable-footer
    *ngIf="footerHeight"
    [rowCount]="rowCount"
    [pageSize]="pageSize"
    [offset]="offset"
    [footerHeight]="footerHeight"
    [footerTemplate]="footer"
    [totalMessage]="messages.totalMessage"
    [pagerLeftArrowIcon]="cssClasses.pagerLeftArrow"
    [pagerRightArrowIcon]="cssClasses.pagerRightArrow"
    [pagerPreviousIcon]="cssClasses.pagerPrevious"
    [selectedCount]="selected.length"
    [selectedMessage]="!!selectionType && messages.selectedMessage"
    [pagerNextIcon]="cssClasses.pagerNext"
    (page)="onFooterPage($event)"
    >
    </rdatatable-footer>
</div>